import { RenderElementProps } from 'slate-react';

export interface QuotePluginOptions {
  isReadOnly?: boolean;
}

export interface BaseQuotePluginProps extends RenderElementProps, QuotePluginOptions {}

export const ELEMENT_QUOTE = 'blog-blockquote';
export const ELEMENT_QUOTE_CONTENT = `${ELEMENT_QUOTE}-content`;
export const ELEMENT_QUOTE_AUTHOR = `${ELEMENT_QUOTE}-author`;

export const ELEMENT_QUOTE_CLASSNAME = 'blog-editor-blockquote';
export const ELEMENT_QUOTE_CONTENT_CLASSNAME = `${ELEMENT_QUOTE}-content`;
export const ELEMENT_QUOTE_AUTHOR_CLASSNAME = `${ELEMENT_QUOTE}-author`;
